// extracted by mini-css-extract-plugin
export var columnItem = "_dn-3";
export var columnItemDraggable = "_dn-4";
export var dragHandle = "_dn-0";
export var dragHandleHovered = "_dn-1";
export var dropdown = "_dn-5";
export var dropdownContent = "_dn-7";
export var dropdownInner = "_dn-6";
export var filterDropdownHeader = "_dn-8";
export var icon = "_dn-2";
export var sectionDivider = "_dn-9";